import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Blinds = createSvgIcon(
  <path d="M24 0H0v2.25h18.375v1.5H1.5V6h16.875v1.5H1.5v2.25h16.875v1.5H1.5v2.25h16.875v3.968A3.001 3.001 0 0 0 16.5 20.25V24h6v-3.75a3.001 3.001 0 0 0-1.875-2.782V13.5H22.5v-2.25h-1.875v-1.5H22.5V7.5h-1.875V6H22.5V3.75h-1.875v-1.5H24V0Zm-4.5 19.5a.75.75 0 0 1 .75.75v1.5h-1.5v-1.5a.75.75 0 0 1 .75-.75Z" />,
  'Blinds'
);

export { Blinds };